import React from 'react';
import { PROJECTS } from './MyProjects';
import { Project } from './Project';
import ProjectCard from './ProjectCard';
import Identity from './Identity';
import './ProjectsPage.css';

const SHOWN_REASONS = ['AI/ML', 'Web/API'];

const shownProjects = PROJECTS
    .filter((project: Project) => SHOWN_REASONS.includes(project.reason))
    .sort((a, b) => a.ranking! - b.ranking!);

function ProjectsPage() {
    return (
        <>
            <Identity />
            <div className="header projectsHeader"><h1>Projects</h1></div>
            <div id="showProjects">
                {shownProjects.map((item) => (
                    <ProjectCard key={item.id} project={item}></ProjectCard>
                ))}
            </div>
        </>
    );
}

export default ProjectsPage;
